module.exports = __webpack_public_path__ + "img/template-3.7c8cb9ba.webp";